@import "../../../../globalStyles/commons";


:host {
  display: block;
  height: 100%;
  width: 100%;
  --line-color: #{v(--color-primary)};
}

.divider {
  display: flex;
}

.divider:not(.vertical) {
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 1rem;

  .line {
    height: 100%;
  }

  &.connect-start .line-start {
    width: 1rem;
    margin-left: 1rem;
    border-inline-start: 1px solid var(--compound-type-line-color);
    border-top: 1px solid var(--compound-type-line-color);
    border-radius: 5px 0 0 0;
  }

  &:not(.connect-start) .line-start {
    border-inline-start: 1px solid var(--compound-type-line-color);
  }

  &.connect-end .line-end {
    width: 1rem;
    margin-left: 1rem;
    border-inline-start: 1px solid var(--compound-type-line-color);
    border-bottom: 1px solid var(--compound-type-line-color);
    border-radius: 0 0 0 5px;
  }

  &:not(.connect-end) .line-end {
    border-inline-start: 1px solid var(--compound-type-line-color);
  }


  .content {
    padding: var(--spacing-02) 0;
  }


}


.divider.vertical {
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .line {
    width: 100%;
  }

  &.connect-start .line-start {
    height: 1rem;
    margin-top: 1rem;
    border-top: 1px solid var(--compound-type-line-color);
    border-left: 1px solid var(--compound-type-line-color);
    border-radius: 5px 0 0 0;
  }

  &:not(.connect-start) .line-start {
    border-top: 1px solid var(--compound-type-line-color);
  }

  &.connect-end .line-end {
    height: 1rem;
    margin-top: 1rem;
    border-top: 1px solid var(--compound-type-line-color);
    border-right: 1px solid var(--compound-type-line-color);
    border-radius: 0 5px 0 0;
  }

  &:not(.connect-end) .line-end {
    border-top: 1px solid var(--compound-type-line-color);
  }


  .content {
    padding: 0 var(--spacing-02);
  }


}
